import { GET_CART_DETAILS} from './types';
export const CartDetailsAction = (cartDetails) => dispatch => {
    console.log('cartDetails in redux...',cartDetails);
    dispatch({
        type: GET_CART_DETAILS,
        cartDetails: cartDetails
    })

}